import { type SavedPlotRow } from "../types";
import { type GridSelectionModel, type GridColDef } from "@mui/x-data-grid";
import { StyledDataGrid } from "@/components/DataGrid/KaokuNumberSearchStyleDataGrid";
import { format, parseISO } from "date-fns";

interface IProps {
  handleRowSelectionChange: (newSelectionModel: GridSelectionModel) => void;
  rows: SavedPlotRow[];
  selectedIds: GridSelectionModel;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  pageSize: number;
  setPageSize: React.Dispatch<React.SetStateAction<number>>;
}

export const SavedPlotFeedGrid: React.FC<IProps> = ({
  handleRowSelectionChange,
  rows,
  selectedIds,
  page,
  setPage,
  pageSize,
  setPageSize,
}) => {
  // DataGrid の内部ページネーションに合わせ、現在表示中のページの選択状態は自動的に管理されるので
  // 全体の選択状態をそのまま渡す
  const currentPageSelection = selectedIds;

  const handlePageChange = (newPage: number): void => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newPageSize: number): void => {
    setPageSize(newPageSize);
  };

  const formatDate = (dateString: string): string => {
    try {
      // ISO 8601形式の日付文字列を解析
      const date = parseISO(dateString);
      return format(date, "yyyy-MM-dd HH:mm:ss");
    } catch (e) {
      console.error("日付のフォーマットに失敗しました:", dateString, e);
      return dateString; // フォーマットに失敗した場合は元の文字列を返す
    }
  };

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "識別名",
      width: 300,
      sortable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "count",
      headerName: "件数",
      width: 100,
      sortable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "createdAt",
      headerName: "保存日時",
      width: 200,
      sortable: true,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        if (params.value && typeof params.value === "string") {
          return formatDate(params.value);
        }
        return "";
      },
    },
  ];

  return (
    <StyledDataGrid
      disableColumnMenu
      rows={rows}
      columns={columns}
      checkboxSelection
      selectionModel={currentPageSelection}
      page={page}
      pageSize={pageSize}
      onPageChange={handlePageChange}
      onPageSizeChange={handlePageSizeChange}
      pagination
      rowsPerPageOptions={[25, 50, 100]}
      initialState={{
        sorting: {
          sortModel: [{ field: "createdAt", sort: "desc" }],
        },
        columns: {
          columnVisibilityModel: { id: false },
        },
      }}
      onSelectionModelChange={handleRowSelectionChange}
    />
  );
};
